import { Heading, Link, Text, Button, CSSObject } from "@chakra-ui/react"
import * as React from "react"
import { navigate } from "gatsby-link"
import { colors } from "../colors/colors"
import { usePurchasingCTAs } from "./usePurchasingCTAs"

export function AuthHeader({ title, subText, subCta, clickableColor, subCtaLink, fontFamily }) {
  return (
    <>
      <Heading
        fontSize="36px"
        lineHeight="24px"
        color={clickableColor || "black"}
        fontWeight="600"
        textAlign="left"
        mb={{ base: `20px`, lg: "20px" }}
      >
        {title}
      </Heading>
      <Text
        fontSize="16px"
        lineHeight="18px"
        color="black"
        letterSpacing="-0.26px"
        textAlign="left"
        fontFamily={fontFamily}
      >
        <Text as="span" fontFamily={fontFamily}>
          {subText}
        </Text>{" "}
        <Link
          color={clickableColor || colors.blue}
          onClick={() => navigate(subCtaLink)}
          fontFamily={fontFamily}
        >
          {subCta}
        </Link>
      </Text>
    </>
  )
}

export function AuthButton({
  label,
  onClick,
  buttonColor,
  buttonTextColor,
  buttonHover,
  marginTop,
  ...rest
}: {
  label: any
  buttonColor?: string
  buttonTextColor?: string
  buttonHover?: CSSObject
  marginTop?: string
  onClick?: any
}) {
  const { button } = usePurchasingCTAs()
  return (
    <Button
    style={{
      marginTop: marginTop || '30px'
    }}
      mt="0"
      borderRadius="50px"
      type="submit"
      bg={buttonColor || button.bg}
      color={buttonTextColor || button.color}
      fontFamily="Teko"
      height="60px"
      textTransform="uppercase"
      _hover={buttonHover || button._hover}
      fontSize="20px"
      lineHeight="35px"
      letterSpacing="1px"
      width="100%"
      onClick={onClick}
      {...rest}
    >
      {label}
    </Button>
  )
}

export const inputStyles = {
  borderRadius: "0px",
  height: "48px",
  fontFamily: "Lato, system-ui, sans-serif",
  fontSize: "16px",
  lineHeight: "35px",
  letterSpacing: "0px",
  bg: `white`,
  border: `1px solid #AEAEB2`,
  // color: `#8E8E93`,
  color: `black`,
}
